import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../openapi';

@Pipe({
  name: 'documentIssuePurposeLabel',
  standalone: true
})
export class DocumentIssuePurposeLabelPipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (application?.service?.url) {
      case '/zaswiadczenie-z-mpzp': {
        return 'Niniejsze zaświadczenie z MPZP niezbędne jest do';
      }
      case '/zaswiadczenie-ze-studium': {
        return 'Niniejsze zaświadczenie ze Studium niezbędne jest do'
      }
      default: {
        return 'Niniejszy wypis i/ wyrys niezbędny jest do';
      }
    }
  }

}
